import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("bedee_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("bedee_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("bedee_user", JSON.stringify(r.data));
      })
      .catch(() => {
        localStorage.removeItem("bedee_token");
        localStorage.removeItem("bedee_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("bedee_token", r.data.access_token);
    // Récupérer les permissions à jour depuis /me (inclut allowed_routes)
    const me = await api.get("/auth/me");
    localStorage.setItem("bedee_user", JSON.stringify(me.data));
    setUser(me.data);
    return me.data;
  };

  const register = async (email, password, name, orgName) => {
    const r = await api.post("/auth/register", { email, password, name, org_name: orgName });
    localStorage.setItem("bedee_token", r.data.access_token);
    localStorage.setItem("bedee_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const acceptInvitation = async (token, password, name) => {
    const r = await api.post("/auth/accept-invitation", { token, password, name });
    localStorage.setItem("bedee_token", r.data.access_token);
    localStorage.setItem("bedee_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("bedee_token");
    localStorage.removeItem("bedee_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{ user, loading, login, register, acceptInvitation, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
